import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProjectPermissionService } from '@services/coding/project-permission.service';
import { environment } from '../../environments/environment';

@Injectable()
export class ProjectTokenInterceptor implements HttpInterceptor {
  private readonly permissionService = inject(ProjectPermissionService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.startsWith(environment.apiUrl)) return next.handle(req);

    const projectId = this.permissionService.currentProjectId();
    if (projectId === null) return next.handle(req);

    const token = this.permissionService.getProjectToken(projectId);
    if (!token) return next.handle(req);

    return next.handle(req.clone({ setHeaders: { 'X-Project-Token': token } }));
  }
}
